import { useSelectableSystemsQuery } from "@common/hooks/useSelectableItemQueries.ts";
import { useAccessibleLinkedEntities } from "@common/components/linkedEntityCollapseList/useAccessibleLinkedEntities.ts";
import { useUrlProvider } from "../../../useUrlProvider.ts";
import { ProcessAssetsFieldProps } from "./ProcessAssetsField.tsx";

interface AccessibleSystemSuppliers {
    id: string;
    suppliers: Array<string>;
}

export function useProcessAssetsField(props: ProcessAssetsFieldProps) {
    const { getSystemOverviewUrl } = useUrlProvider();
    const { isLoading, data } = useSelectableSystemsQuery(!props.isPreview);
    const { getAccessibleEntity, isEntityLoading } = useAccessibleLinkedEntities<AccessibleSystemSuppliers>(
        "/system/accessible-supplier-details",
        props.assetIds,
        !props.isPreview
    );

    function getLinkTo(id: string) {
        return getAccessibleEntity(id) ? getSystemOverviewUrl(id) : undefined;
    }

    function getSuppliers(id: string) {
        return getAccessibleEntity(id)?.suppliers;
    }

    return { isLoading, data, getLinkTo, getSuppliers, isSuppliersLoading: isEntityLoading };
}
